import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  commercial: "https://images.pexels.com/photos/29248902/pexels-photo-29248902.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

const CommercialService = () => {
  return (
    <ServicePageTemplate
      title="Commercial Plumbing"
      subtitle="Business Plumbing Solutions"
      image={ASSETS.commercial}
      description="BNPH provides professional commercial plumbing services for businesses, office buildings, retail spaces, and industrial facilities throughout the Twin Cities. We understand the importance of minimizing downtime and ensuring your business operations continue smoothly."
      features={[
        'Experienced commercial plumbing technicians',
        'Minimal disruption to your business operations',
        'Code compliance expertise',
        'Scheduled maintenance programs',
        'Priority commercial services',
        'New construction and tenant improvements',
      ]}
      services={[
        'Commercial Kitchens',
        'Restroom Plumbing',
        'Industrial Piping',
        'Backflow Prevention & Testing',
        'RPZ Testing & Rebuilding',
        'Water Heater Systems',
        'Boiler Systems',
        'Grease Trap Services',
        'Floor Drain Maintenance',
        'Priority Repairs',
        'New Construction',
        'Tenant Improvements',
      ]}
      relatedServices={[
        { title: 'Boilers', link: '/services/boilers', description: 'Commercial boiler installation and maintenance.' },
        { title: 'Air Conditioning', link: '/services/air-conditioning', description: 'Commercial HVAC services.' },
        { title: 'Water Heaters', link: '/services/water-heaters', description: 'Commercial water heating solutions.' },
      ]}
    />
  );
};

export default CommercialService;
